import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import CursorGlow from "@/components/CursorGlow";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Join from "@/pages/Join";
import Dashboard from "@/pages/Dashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Certificate from "@/pages/Certificate";
import Complete from "@/pages/Complete";
import Practice from "@/pages/Practice";
import AdminLeads from "@/pages/AdminLeads";

function NotFound() {
  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="not-found">
      <div className="text-center max-w-md">
        <p className="text-[11px] uppercase tracking-[0.24em] text-gold-dark font-bold mb-4">Off the path</p>
        <h1 className="font-heading text-purple text-5xl mb-4">Nothing here</h1>
        <p className="text-lav mb-8">This page seems to have quietly disappeared. Let's get you back.</p>
        <a href="/" className="inline-flex items-center gap-2 bg-purple-deep text-cream font-bold rounded-full px-8 py-4 hover:bg-purple transition-colors">
          Back to the beginning
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <CursorGlow />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/join" element={<Join />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requireAccess>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/complete"
              element={
                <ProtectedRoute requireAccess>
                  <Complete />
                </ProtectedRoute>
              }
            />
            <Route
              path="/certificate"
              element={
                <ProtectedRoute requireAccess>
                  <Certificate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/practice"
              element={
                <ProtectedRoute requireAccess>
                  <Practice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/leads"
              element={
                <ProtectedRoute>
                  <AdminLeads />
                </ProtectedRoute>
              }
            />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: "#221452", color: "#F5F3FC", border: "1px solid #D4AF37" },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
